import { DatePicker } from "rsuite";
import useDateObject from "./useDateObject";

const DateInput = ({
  inputSize,
  field,
  onChange,
  value,
  disabled = false,
  setIsOpen, // State setter passed from parent to update open state
  isRecord = false,
}) => {
  const { dateValue, setDateValue } = useDateObject(value, "MM-DD-YYYY");

  return (
    <DatePicker
      id={isRecord ? undefined : `record-input-${field.APIName}`}
      format="MM-dd-yyyy"
      placeholder="MM-DD-YYYY"
      placement="autoVerticalStart"
      onOpen={updateOpen(true)}
      onClose={updateOpen(false)}
      value={dateValue}
      onSelect={handleChange}
      size={inputSize}
      disabled={disabled}
      onClean={() => handleChange(null)}
      block
      preventOverflow
      cleanable={!field?.Required}
    />
  );

  // The newDate from the DatePicker component is a Date object or null.
  // I didn't add any extra logic because `InstanceUtils.formatInputComponentResponse` will convert it.
  function handleChange(newDate) {
    onChange(newDate);
    setDateValue(newDate);
  }

  // This allows the parent to know when this component is open.
  function updateOpen(open) {
    if (typeof setIsOpen !== "function") return null;

    return () => setIsOpen(open);
  }
};

export default DateInput;
